import { SubscriptionFeeSubType, } from "@domains/entities/interfaces/Reports/SubscriptionReport/ISubscriptionReport";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
import { ReportType, ReportName, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
class SubscriptionReport {
    constructor(useCases, actions, sendEmailReports, downloadPDFReports, downloadExcelReports) {
        this.useCases = useCases;
        this.actions = actions;
        this.sendEmailReports = sendEmailReports;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.emailList = [];
    }
    getSubscriptionFee(req) {
        this.actions.subscription.hideError("SubscriptionFee");
        this.actions.subscription.loader("SubscriptionFee");
        this.actions.subscription.clear("SubscriptionFee");
        this.useCases.subscriptionFee.execute({
            onSuccess: (data) => {
                if ((req.subType === SubscriptionFeeSubType.RATE &&
                    data.rateBased.length < 1) ||
                    (req.subType === SubscriptionFeeSubType.VOLUME &&
                        data.volBased.length < 1)) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.SUBSCRIPTION];
                    this.actions.subscription.addMsg(emptyValidation.message, true, emptyValidation.icon, "SubscriptionFee");
                }
                this.actions.subscription.getSubscriptionFee(data, "SubscriptionFee");
                this.actions.subscription.stopLoader("SubscriptionFee");
            },
            onError: (error) => {
                this.actions.subscription.setError({
                    isOpen: true,
                    error,
                }, "SubscriptionFee");
                this.actions.subscription.stopLoader("SubscriptionFee");
            },
        }, req);
    }
    async downloadAndSendSubsReport(email, download, subType) {
        let emailPayload = null, downloadPayload = null;
        if (email)
            emailPayload = {
                reportName: email.reportName,
                reportType: email.reportType,
                subReportName: email.subReportName,
                emailIds: email.emailIds,
                accodes: email.accodes,
            };
        if (download)
            downloadPayload = {
                reportType: download.reportType,
                accodes: download.accodes,
            };
        try {
            if (emailPayload && downloadPayload) {
                const emailResult = await this.sendSubsEmail(emailPayload, subType);
                const downloadResult = await this.DownloadSubscriptionFee(downloadPayload, subType);
                return emailResult && downloadResult;
            }
            else if (email)
                return await this.sendSubsEmail(emailPayload, subType);
            else if (download)
                return await this.DownloadSubscriptionFee(downloadPayload, subType);
            throw false;
        }
        catch (error) {
            throw false;
        }
    }
    async DownloadSubscriptionFee(downloadPayload, subType) {
        if (downloadPayload.reportType == ReportType.PDF)
            return await this.downloadSubsHelper(this.downloadPDFReports, downloadPayload, subType);
        return await this.downloadSubsHelper(this.downloadExcelReports, downloadPayload, subType);
    }
    async downloadSubsHelper(DType, downloadPayload, subType) {
        downloadPayload.reportName = ReportName.SUBSCRIPTION;
        downloadPayload.subReportName = subType;
        return new Promise((resolve, reject) => {
            DType.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, downloadPayload);
        });
    }
    async sendSubsEmail(req, subType) {
        req.reportName = ReportName.SUBSCRIPTION;
        this.emailList = req.emailIds;
        req.subReportName = subType;
        return new Promise((resolve, reject) => {
            this.sendEmailReports.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    getSubscriptionPopup(req) {
        return new Promise((resolve, reject) => {
            this.useCases.subscriptionPopup.execute({
                onSuccess: (popupData) => {
                    resolve(popupData);
                },
                onError: (error) => {
                    reject({ error: error, isOpen: true });
                }
            }, req);
        });
    }
    async emailSubscriptionPopup(req) {
        return new Promise((resolve, reject) => {
            this.useCases.subscriptionPopupEmail.execute({
                onSuccess: (emailResponse) => {
                    resolve(emailResponse);
                },
                onError: (error) => {
                    reject({ error: error, isOpen: true });
                }
            }, req);
        });
    }
}
export default SubscriptionReport;
